export const errorMessages = {
	error_exchange_rate: "Please Enter Exchange Rate",	
	error_select_reason: "Please Select the Reason",	
	error_emailid: "Please Enter Username and Email",
	error_password: "Please Enter password",
	error_entity: "Please Enter Entity",
	error_sub_entity: "Please Enter SubEntity",
	error_country: "Please Enter Country",
	error_currency: "Please Enter Currency",
	error_remitter_acc_no: "Please Enter Remitter Account No",
	error_remitter_bank_name: "Please Enter Remitter Bank Name",
	error_portcall_no: "Please Enter Portcall No",
	error_dastatus: "Please Enter DA Status",
	error_vmd_id: "Please Enter VMD Id",
	error_amount: "Please Enter Amount",
	error_initiate_date: "Please Enter Initiate Date",
	error_value_date: "Please Enter Value Date",
	error_TO_date: "Please Enter To Date",
	error_agent_name: "Please Enter Agent Name",
	error_be_country: "Please Enter Benefiary Country",
	error_be_currency: "Please Enter Benefiary Currency",
	error_bank_accountno: "Please Enter Bank Account No",
	error_benefiary_name: "Please Enter Benefiary Name",
	error_benefiary_accountno: "Please Enter Benefiary Account No",
	error_benefiary_bank_name: "Please Enter Benefiary Bank Name",
	error_autocomplete_message: " is Required",
	error_type_message: "Please Select Type",
	error_reshedule_date: "Please Enter Reshedule Date",
	error_Mandatory_field: "Mandatory field!.",
	error_Suggested_Account_No: "Please enter suggested account number",
	error_Buffer_message: "Buffer amount  is Required",
	error_amount: "Amount  is Required",

};